import { Currency } from '@/core/currency/interfaces';

const TND: Currency = {
    name: 'Tunisian Dinar',
    demonym: 'Tunisian',
    majorSingle: 'Dinar',
    majorPlural: 'Dinars',
    codeNumeric: '788',
    symbol: 'DT',
    symbolNative: 'د.ت.',
    minorSingle: 'Millime',
    minorPlural: 'Millime',
    ISOdigits: 3,
    decimals: 3,
    numToBasic: 1000,
    code: 'TND',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default TND;
